
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSApprovalLaborGrid extends Serenity.EntityGrid<POSApprovalLaborRow, any> {
        protected getColumnsKey() { return 'Retail.POSApprovalLabor'; }
        protected getIdProperty() { return POSApprovalLaborRow.idProperty; }
        protected getInsertPermission() { return POSApprovalLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return POSApprovalLaborRow.localTextPrefix; }
        protected getService() { return POSApprovalLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}